/**
 * Turns whatever an auth request threw into something a page can render.
 * Nothing here ever returns an empty message: an unrecognised failure is a
 * 'server' kind, which the pages map to the prototype's server-error banner.
 */
export const DEFAULT_RETRY_SECONDS = 60;

const num = (v) => {
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};

/** @returns {{kind:'offline'|'rate'|'unauthorized'|'validation'|'client'|'server', status:number|null, retryAfter:number, message:string, errors:object}} */
export function classify(error) {
  const res = error?.response;
  if (!res) {
    return { kind: 'offline', status: null, retryAfter: 0, message: '', errors: {}, code: '' };
  }
  const status = res.status;
  const body = res.data && typeof res.data === 'object' ? res.data : {};
  const message = String(body.message || body.msg || '');
  const errors = body.errors && typeof body.errors === 'object' ? body.errors : {};
  const code = typeof body.code === 'string' ? body.code : '';

  if (status === 429) {
    const header = num(res.headers?.['retry-after']);
    const retryAfter = header && header > 0 ? Math.min(header, 3600) : DEFAULT_RETRY_SECONDS;
    return { kind: 'rate', status, retryAfter, message, errors, code };
  }
  if (status === 401 || status === 403) return { kind: 'unauthorized', status, retryAfter: 0, message, errors, code };
  if (status === 422) return { kind: 'validation', status, retryAfter: 0, message, errors, code };
  if (status >= 400 && status < 500) return { kind: 'client', status, retryAfter: 0, message, errors, code };
  return { kind: 'server', status, retryAfter: 0, message, errors, code };
}

/** First message of a Laravel `errors.<field>` entry (string or array). */
export const firstError = (errors, ...fields) => {
  for (const f of fields) {
    const v = errors?.[f];
    const s = Array.isArray(v) ? v[0] : v;
    if (s) return String(s);
  }
  return '';
};

export const isTakenMessage = (m) => /taken|already|registered|exist/i.test(m || '');
export const isDisposableMessage = (m) => /disposable|temporary|throwaway/i.test(m || '');
export const isExpiredMessage = (m) => /expired/i.test(m || '');
